import { BasicColorTypes } from './colorTypes';

export const DEFAULT_VALUES = {
  text: '#6AA1E1',
  colorType: BasicColorTypes.HEX,
  filter:
    'brightness(0) saturate(100%) invert(77%) sepia(67%) saturate(634%) hue-rotate(173deg) brightness(100%) contrast(97%)',
};
